import {
  NativeSyntheticEvent,
  Platform,
  TextInputKeyPressEventData,
} from 'react-native';

/**
 * On the web, Enter sends and Shift+Enter breaks the line, as in any chat.
 * Enter while an IME is composing (pinyin) only picks the candidate.
 */
export function submitOnEnter(send: () => void) {
  if (Platform.OS !== 'web') return undefined;
  return (event: NativeSyntheticEvent<TextInputKeyPressEventData>) => {
    const native = event.nativeEvent as TextInputKeyPressEventData & {
      shiftKey?: boolean;
      isComposing?: boolean;
    };
    if (native.key !== 'Enter' || native.shiftKey || native.isComposing) return;
    event.preventDefault();
    send();
  };
}
